
import { MainPublicationDiscussingModel } from '../models/MainPublicationDiscussingModel.js';
import { MainPublicationDiscussingView } from '../views/MainPublicationDiscussingView.js';

export class MainPublicationDiscussingController {
    constructor() {

        this.model = new MainPublicationDiscussingModel();
        this.view = new MainPublicationDiscussingView();

        this.model.subscribe(state => this.view.render(state));
    }
}